import { makeStyles } from '@mui/styles';
import { Box } from '@mui/system';
import React, { useState } from 'react';
import Banner from '../../atoms/Banner/Banner';
import Plancard from '../../atoms/Plancard';
import Typography from '../../atoms/Typography/Typography';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    // justifyContent: 'center',
  },

  topBox: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '80px',

    '@media only screen and (max-width: 1280px)': {
      alignItems: 'center',
      width: '90%',
    },
    '@media only screen and (max-width: 768px)': {
      flexDirection: 'column',
    },
  },
  middleBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  btnBox: {
    width: '16vw',
    minHeight: '86px',
    maxHeight: '86px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    marginBottom: '82px',
    '&:hover': {
      cursor: 'pointer',
      // backgroundColor: '#19191910',
    },
    '@media only screen and (max-width: 768px)': {
      width: '90vw',
      minHeight: '46px',
      alignItems: 'center',
      marginBottom: '4px',
      border: 'solid 1px #00000030',
    },
  },
  btnText: {
    width: '70%',
    opacity: 0.5,
    fontFamily: 'Pretendard',
    fontSize: '20px',
    fontWeight: 600,
    textAlign: 'center',
    color: '#191919',
    '@media only screen and (max-width: 1200px)': {
      fontSize: '14px',
    },
  },

  selectedBox: {
    backgroundColor: '#00000030',
    '@media only screen and (max-width: 768px)': {
      backgroundColor: 'initial',
    },
  },
  selectedBoxM: {
    // backgroundColor: 'black',

    '@media only screen and (max-width: 768px)': {
      backgroundColor: '#00000020',
      boxSizing: 'border-box',
    },
  },
  selectedText: {
    '@media only screen and (max-width: 768px)': {
      color: 'initial',
    },
  },
  selectedTextM: {
    '@media only screen and (max-width: 768px)': {
      // color: 'white ',
    },
  },
  selectedBottom: {
    '@media only screen and (max-width: 768px)': {
      display: 'flex !important',
    },
  },
  bottomBox: {
    display: 'flex',
    width: '90%',
    justifyContent: 'space-evenly',
    '@media only screen and (max-width: 768px)': {
      display: 'none',
    },
  },
  bottomBoxM: {
    display: 'none',
    width: '90%',
    justifyContent: 'space-evenly',
    '@media only screen and (max-width: 768px)': {
      width: '100%',
      overflow: 'scroll',
      justifyContent: 'left',
    },
  },
  cardBox: {
    justifyContent: 'center',
    '@media only screen and (max-width: 768px)': {
      // border: 'solid 5px red',
      marginLeft: '40px',
    },
  },
  titleName: {
    fontSize: '24px',
    fontFamily: 'Pretendard',
    fontWeight: 600,
    lineHeight: 1.25,
    letterSpacing: '-0.24px',
    textAlign: 'left',
    color: '#191919',
  },

  titleName2: {},
});

const buttonItems = [
  {
    title: 'trainee selection',
  },
  {
    title: 'Stage 1 major education',
  },
  {
    title: '2nd stage team project training',
  },
  {
    title: 'Level 3 Competition Training',
  },
  {
    title: 'Final BEST10 selection and certification',
  },
];

const imageItemsList = [
  [
    {
      ImageSrc: '/images/icon/card/flaticon1.png',
      month: 'April',
      title: 'Pre-preparation period',
      text: [
        {
          line: '- Mentor Selection',
        },
        {
          line: '- Opening of training courses for each track',
        },
        {
          line: '- system improvement',
        },
        {
          line: '- Selection of textbooks',
        },
        {
          line: '- Education Center Inspection',
        },
      ],
    },
    {
      ImageSrc: '/images/icon/card/flaticon2.png',
      month: 'May',
      title: 'Student application reception',
      text: [
        {
          line: '- Trainee Recruitment Notice',
        },
        {
          line: '- Recruitment briefing session',
        },
        {
          line: '- Application through the website',
        },
        {
          line: '',
        },
        {
          line: '',
        },
      ],
    },
    {
      ImageSrc: '/images/icon/card/flaticon3.png',

      month: 'June',

      title: 'Selection of successful candidates',

      text: [
        {
          line: '- Selection of successful trainees',
        },
        {
          line: '- Orientation for successful trainees',
        },
        {
          line: '',
        },
        {
          line: '',
        },
        {
          line: '',
        },
      ],
    },
  ],
  [
    {
      ImageSrc: '/images/icon/card/flaticon4.png',

      month: 'July',
      title: 'Inauguration ceremony',
      text: [
        {
          line: '- major education',
        },
        {
          line: '- common education',
        },
        {
          line: '- basic literacy education',
        },
        {
          line: '- Celebrity Lecture',
        },
        {
          line: '',
        },
      ],
    },
    {
      ImageSrc: '/images/icon/card/flaticon5.png',

      month: 'August',
      title: 'Track training',
      text: [
        {
          line: '- major education',
        },
        {
          line: '- Membership training',
        },
        {
          line: '- Security industrial facility tour',
        },
        {
          line: '- 1st stage education evaluation',
        },
        {
          line: '',
        },
      ],
    },
  ],
  [
    {
      ImageSrc: '/images/icon/card/flaticon6.png',

      month: 'July',
      title: 'Inauguration ceremony',
      text: [
        {
          line: '-major education',
        },
        {
          line: '-common education',
        },
        {
          line: '-basic literacy education',
        },
        {
          line: '-Celebrity Lecture',
        },
        {
          line: '',
        },
      ],
    },
    {
      ImageSrc: '/images/icon/card/flaticon7.png',

      month: 'July',
      title: 'Inauguration ceremony',
      text: [
        {
          line: '-major education',
        },
        {
          line: '-common education',
        },
        {
          line: '-basic literacy education',
        },
        {
          line: '-Celebrity Lecture',
        },
        {
          line: '',
        },
      ],
    },
    {
      ImageSrc: '/images/icon/card/flaticon8.png',
      month: 'July',
      title: 'Inauguration ceremony',
      text: [
        {
          line: '-major education',
        },
        {
          line: '-common education',
        },
        {
          line: '-basic literacy education',
        },
        {
          line: '-Celebrity Lecture',
        },
        {
          line: '',
        },
      ],
    },
    {
      ImageSrc: '/images/icon/card/flaticon9.png',

      month: 'July',
      title: 'Inauguration ceremony',
      text: [
        {
          line: '-major education',
        },
        {
          line: '-common education',
        },
        {
          line: '-basic literacy education',
        },
        {
          line: '-Celebrity Lecture',
        },
        {
          line: '',
        },
      ],
    },
  ],
  [
    {
      ImageSrc: '/images/icon/card/flaticon10.png',

      month: 'January',
      title: 'Further education',
      text: [
        {
          line: '-Track Intensive Education',
        },
        {
          line: '-Project sophistication',
        },
        {
          line: '-State institution tour',
        },
        {
          line: '-Celebrity Lecture',
        },
        {
          line: '',
        },
      ],
    },

    {
      ImageSrc: '/images/icon/card/flaticon11.png',

      month: 'February',
      title: 'Contest Announcement',
      text: [
        {
          line: '-Contest Announcement Evaluation',
        },
        {
          line: '-Grand Prix Presentation Evaluation',
        },
        {
          line: '-completion evaluation',
        },
        {
          line: '-Step 3 Educational Evaluation',
        },
        {
          line: '',
        },
      ],
    },
  ],

  [
    {
      ImageSrc: '/images/icon/card/flaticon12.png',
      month: 'March',
      title: 'Top Talent and Grand Prix Selection',
      text: [
        {
          line: '-graduation ceremony',
        },
        {
          line: '-authentication',
        },
        {
          line: '-overseas study',
        },
        {
          line: '',
        },
        {
          line: '',
        },
      ],
    },
  ],
];

const bannerData = {
  imgSrc: '/images/image/message title@2x.png',
  imgSrcM: '/images/image/messagem title@2x.png',
  title: 'Education Process Plan',
  text1: 'A comprehensive view of the Best of the Best training programs.',
};

export default function CenterPage() {
  const classes = useStyles();

  const [selectBtn, setSelectBtn] = useState(0);
  const [selectBtnM, setSelectBtnM] = useState(0);

  const ChangeBottomImage1 = (btn, i) => {
    if (i === selectBtnM) {
      setSelectBtnM(-1);
    } else setSelectBtnM(i);

    setSelectBtn(i);
  };

  return (
    <Box className={classes.root}>
      <Box className={classes.textBox}>
        <Banner bannerData={bannerData} />
      </Box>
      <Box className={classes.topBox}>
        {buttonItems.map((btn, i) => {
          return (
            <Box key={i} className={classes.middleBox}>
              <Box
                className={`${classes.btnBox} processBox ${selectBtn === i && classes.selectedBox} ${selectBtnM === i && classes.selectedBoxM}`}
                onClick={ChangeBottomImage1.bind(this, btn, i)}
              >
                <Typography className={`${classes.btnText} ${selectBtn === i && classes.selectedText} ${selectBtnM === i && classes.selectedTextM}`}>{btn.title}</Typography>
              </Box>
              <Box className={`${classes.bottomBoxM} ${selectBtnM === i && classes.selectedBottom}`}>
                {selectBtnM !== -1 &&
                  imageItemsList[selectBtnM].map((data, i) => {
                    return (
                      <Box key={i} className={classes.cardBox}>
                        <Plancard data={data} />
                      </Box>
                    );
                  })}
              </Box>
            </Box>
          );
        })}
      </Box>
      <Box className={classes.bottomBox}>
        {imageItemsList[selectBtn].map((data, i) => {
          return (
            <Box key={i} className={classes.cardBox}>
              <Plancard data={data} />
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
